module.exports = __webpack_public_path__ + "static/media/2.feb3d1e0.png";